import React, { PropsWithChildren } from "react";
import { ConfigProvider } from "antd";

const AntdProvider: React.FC<PropsWithChildren> = ({ children }) => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "#0C4A6E",
          colorText: "#0C4A6E",
          fontSize: 16,
          borderRadius: 4,
          fontFamily: "'Inter', sans-serif",
          colorError: "#EF4444",
        },
        components: {
          Alert: {
            colorSuccessBg: "#F0FDF4",
            colorWarningBg: "#FFF7ED",
          },
          Button: {
            colorPrimary: "#00adef",
            colorPrimaryHover: "#009cd6",
            colorPrimaryActive: "#008bbd",
            controlOutline: "none",
            primaryShadow: "none",
            contentFontSize: 16,
            borderRadius: 8,
            contentLineHeight: 40,
            controlHeight: 40,
          },
          Slider: {
            trackBg: "#0C4A6E",
            trackHoverBg: "#0C4A6E",
            handleColor: "#00adef",
            handleActiveColor: "#00adef",
            handleSize: 12,
            handleSizeHover: 12,
            handleLineWidth: 6,
            handleLineWidthHover: 6,
            handleColorDisabled: "#00adef",
            handleActiveOutlineColor: "#00adef",
            railSize: 8,
          },

          Select: {
            colorIcon: "#0C4A6E",
            colorTextQuaternary: "#0C4A6E",
            colorTextDescription: "#0C4A6E",
          },
        },
      }}
    >
      {children}
    </ConfigProvider>
  );
};

export default AntdProvider;
